export default "__VITE_ASSET__DbsXhStL__"